// Copy text to clipboard. Works on HTTPS (Clipboard API) and HTTP / WebViews (execCommand fallback).
// Always resolves to true/false; never throws.
const legacyCopy = (text) => {
  if (typeof document === 'undefined' || !document.body) return false;
  const active = document.activeElement;
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('aria-hidden', 'true');
  // Must stay "visible" to the browser (no display:none) or Android won't select it.
  ta.style.position = 'fixed';
  ta.style.top = '0';
  ta.style.left = '0';
  ta.style.width = '1px';
  ta.style.height = '1px';
  ta.style.padding = '0';
  ta.style.border = 'none';
  ta.style.outline = 'none';
  ta.style.boxShadow = 'none';
  ta.style.background = 'transparent';
  ta.style.opacity = '0';
  ta.style.fontSize = '16px'; // prevents zoom on mobile focus
  document.body.appendChild(ta);
  let ok = false;
  try {
    ta.focus({ preventScroll: true });
    ta.select();
    ta.setSelectionRange(0, text.length); // needed for Android/iOS WebViews
    ok = document.execCommand('copy');
  } catch (e) {
    ok = false;
  } finally {
    document.body.removeChild(ta);
    try { if (active && active.focus) active.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
  }
  return ok;
};

export const copyText = async (text) => {
  const value = text == null ? '' : String(text);
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function' && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (e) {
      // permission denied / document not focused -> try legacy path
    }
  }
  return legacyCopy(value);
};

export default copyText;
